<template>
  <view wx:if="{{accounts.length}}" class="container">
    <view class="title">历史12306账号</view>
    <view
      class="account"
      wx:for="{{accounts}}"
      wx:key="index"
    >
      <view class="username">{{item.account_with_star}}<text class="tag" wx:if="{{item.login}}">(当前登录)</text></view>
      <view class="action">
        <block wx:if="{{item.login}}">
          <view bindtap="handleActionPrev(item, 'logout')" class="action-item">退出登录</view>
          <view wx:if="{{isMini}}" bindtap="toPassenger" class="action-item">查看乘车人</view>
        </block>
        <block wx:else>
          <view bindtap="loginAction(item)" class="action-item">一键登录</view>
          <view bindtap="handleActionPrev(item, 'delete')" class="action-item">删除</view>
        </block>
      </view>
    </view>
    <!-- 退出弹窗 -->
    <es-dialog
      showCancelButton
      showConfirmButton
      title="温馨提示"
      show="{{show}}"
      algin="center"
      bind:cancel="onCancel"
      bind:confirm="onConfirm"
    >
      <view slot="content">{{ dialogMsg }}</view>
    </es-dialog>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { isWXMini, isALIMini } from '@/common/constant'
  createComponent({
    data() {
      return {
        show: false,
        choosedAccount: null,
        dialogType: '',
      }
    },
    computed: {
      ...store.mapGetters({
        accounts: 'login12306.historyAccount'
      }),
      isMini() {
        return isWXMini || isALIMini
      },
      dialogMsg() {
        const msgMap = {
          'logout': '您确定要退出该账号？',
          'delete': '您确定要删除该账号？'
        }
        return msgMap[this.dialogType]
      }
    },
    methods: {
      ...store.mapActions({
        loginOutAction12306: 'login12306.loginOutAction12306',
        delete12306UserAccount: 'login12306.delete12306UserAccount',
        loginAction12306: 'login12306.loginAction12306',
      }),
      ...store.mapMutations({
        setChangeUserStatus: 'login12306.setChangeUserStatus',
        setTravelerList: 'contacts.setTravelerList',
      }),
      toPassenger() {
        this.setChangeUserStatus(false)
      },
      handleActionPrev(item, type) {
        this.dialogType = type
        this.choosedAccount = item
        this.show = true
      },
      onCancel() {
        this.show = false
      },
      onConfirm() {
        this.show = false
        switch (this.dialogType) {
          case 'logout':
            this.loginOutAction12306({ phone: this.choosedAccount.account_with_star })
            break
          case 'delete':
            this.delete12306UserAccount({ account_number: this.choosedAccount.account })
            break
        }
      },
      loginAction({ account, account_with_star }) {
        this.setTravelerList([])
        this.loginAction12306({
          type: 1,
          account,
          account_with_star,
        })
      }
    },
    destroyed() {
      this.setChangeUserStatus(false)
    }
  })
</script>

<style lang='stylus' scoped>
.container
  border-radius 8px
  box-sizing border-box
  border 1px solid #EEEEEE
  padding 12px 12px 16px
  .title
    font-family PingFangSC-Regular
    font-size 12px
    font-weight normal
    line-height 14px
    letter-spacing 0px
    color #999999
  .username
    overflow hidden
    white-space nowrap
    text-overflow ellipsis
    .tag
      white-space nowrap
  .account
    margin-top 16px
    font-family PingFangSC-Regular
    font-weight 400
    font-size 12px
    height 14px
    line-height 1
    box-sizing border-box
    color #000
    display flex
    align-items center
    justify-content space-between
    .action
      flex none
      color #666
      display flex
      align-items center
      &-item
        padding 8px
        position relative
        &:last-child
          padding-right 0
        &+.action-item
          &::before
            position absolute
            left 0
            top 10px
            content ''
            height 8px
            width 1px
            background-color #c2c2c2
   
</style>

<script name='json'>
  module.exports = {
    component: true,
  }
</script>

